import { financeOperatorsApi } from 'entities/financeOperations/model';
import { HTTP_METHODS } from 'shared/consts';
import { toast } from 'react-toastify';

const updateFinanceOperators = financeOperatorsApi.injectEndpoints({
  endpoints: (builder) => ({
    updateOperator: builder.mutation({
      query: ({ id, data }) => ({
        url: `/wallet/admin/withdrawal_services_types/${id}/`,
        method: HTTP_METHODS.PATCH,
        body: data,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно обновили финансового оператора', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'FinanceOperationId' }];
      },
    }),
  }),
});

export const { useUpdateOperatorMutation } = updateFinanceOperators;
